import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const TreatmentsCategoryWrapper = styled.div`
  width: 100%;
`;

export const TreatmentRow = styled.div<{ isAvailable: boolean }>`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.defaultColors.grey};
  padding: 20px 0;

  background: ${({ isAvailable, theme }) =>
    isAvailable ? '#FFFFFF' : theme.defaultColors.lightGrey};

  &:nth-child(1) {
    border-top: 1px solid ${({ theme }) => theme.defaultColors.grey};
  }

  ${media.xl`
    padding: 20px;
  `}
`;

export const TreatmentListingWrapper = styled.div`
  display: flex;
  padding-top: 32px;
  padding-bottom: 32px;
`;

export const TreatmentListing = styled.div`
  flex-grow: 1;
`;

export const Column = styled.div`
  flex-shrink: 0;
  padding: 0;
  flex-direction: row;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spaces.space5};

  ${media.xl`
    padding: 0 16px;
  `}
`;

export const ButtonColumn = styled(Column)`
  ${media.xl`
    flex-basis: 20%;
    justify-content: flex-end;
  `}
`;

export const NameColumn = styled(Column)`
  flex-grow: 1;
  flex-shrink: 1;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  font-size: 15px;
`;

export const PriceColumn = styled(Column)`
  ${media.xl`
    flex-basis: 20%;
    justify-content: flex-start;
  `}
`;

export const TreatmentPagePreview = styled.div`
  display: none;

  ${media.xl`
    display: flex;
    flex-direction: column;
    width: 426px;
    margin-left: 60px;
  `}
`;

export const TreatmentPageDescription = styled.div`
  margin: 10px 0;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
`;

export const MobileColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  flex-grow: 1;

  ${media.xl`
    flex-direction: row;
    padding: 0;
  `}
`;
